import * as React from 'react';
import { needPremium } from '../../../needPremium';
import { styled } from '@mui/material/styles';
import Tooltip, { tooltipClasses } from '@mui/material/Tooltip';
import { Dialog, DialogContent, IconButton, Slide, } from '@mui/material';
import FileDownloadRoundedIcon from '@mui/icons-material/FileDownloadRounded';
import PremiumBanner from '../../Pricing/PremiumBanner';

const LightTooltip = styled(({ className, ...props }) => (
  <Tooltip {...props} classes={{ popper: className }} />
))(({ theme }) => ({
  [`& .${tooltipClasses.arrow}`]: {
    // color: theme.palette.primary.main,
    color: "#2a2d64",
  },
  [`& .${tooltipClasses.tooltip}`]: {
    // backgroundColor: theme.palette.primary.main,
    backgroundColor: "#2a2d64",
    fontWeight: 600,
    color: '#fff',
    boxShadow: theme.shadows[1],
    fontSize: 11,
    padding: '5px 15px',
  },
}));

const Transition = React.forwardRef(function Transition(props, ref) {
  return <Slide direction="up" ref={ref} {...props} />;
});

const DownloadTableData = (props) => {
  const { user, message, logout, handleDownload, isPremium } = props || {}
  const [banner, setBanner] = React.useState(false);

  const handleDownloadClick = (e) => {
    if (isPremium) {
      handleDownload(e);
    } else {
      setBanner(true);
    }
  };

  const handleBannerClose = () => {
    setBanner(false);
  };

  return (
    <>
      <LightTooltip describeChild title="Download as CSV" placement="top" disableInteractive>
        <IconButton
          onClick={handleDownloadClick} sx={{ mr: 'auto' }}
          data-event-name="download"
          data-event-category="stock-screener"
          data-event-label="csv"
        >
          <FileDownloadRoundedIcon fontSize="small" sx={{ color: 'text.secondary', pointerEvents: 'none' }} />
        </IconButton>
      </LightTooltip>
      <Dialog
        open={banner} onClose={handleBannerClose}
        TransitionComponent={Transition}
        keepMounted
        aria-describedby="auth-dialog"
        maxWidth="md"
        sx={{
          '& .MuiDialog-paper': {
            maxHeight: 'calc(100% - 64px)',
            width: '100% !important',
            transition: 'max-height 2s ease-in-out',
            bgcolor: 'transparent',
            p: '0 !important',
            boxShadow: 0, textAlign: 'center'
          },
          '& .MuiDialogContent-root': { p: 0 },
          '& .MuiBackdrop-root': {
            backdropFilter: 'blur(3px)'
          }
        }}
      >
        <DialogContent sx={{ p: { xs: 0, sm: '' } }}>
          <PremiumBanner maxWidth={12} {...props} isPopup={true} user={user} message={message} screenerBanner={banner} logout={logout} />
        </DialogContent>
      </Dialog>
    </>
  );
}

export default needPremium(DownloadTableData)
